import { HandleSelectProductDetailsProps } from '@frontend/pricing-search';
import Session, { ALL_SUMMARY_PARAMS } from './Session';

export const handleSelectProductDetails = ({
  programID,
  loanId,
  rateDataID,
  lockEffectiveDate,
  wcpPolicyApplied,
}: HandleSelectProductDetailsProps) => {
  Session.set(ALL_SUMMARY_PARAMS, {
    loanId,
    programId: programID,
    rateDataId: rateDataID,
    lockEffectiveDate,
    wcpPolicyApplied,
  });
};
